document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-cookie-preferences]');
  if (!trigger) return;

  const showPreferences = window.Shopify?.customerPrivacy?.showPreferences;
  if (typeof showPreferences === 'function') {
    showPreferences();
    return;
  }

  const nativePreferencesButton = document.querySelector(
    '.shopify-pc__banner__btn-manage-prefs, [data-shopify-cookie-preferences]'
  );

  if (nativePreferencesButton instanceof HTMLElement) {
    nativePreferencesButton.click();
    return;
  }

  window.location.hash = document.getElementById('information-ergaenzen')
    ? 'information-ergaenzen'
    : 'footer-service-links';
});
